import { OrdersSuccessPayload } from "@src/store/orders/types";
import { instance } from "./api";

const per_page = process.env.REACT_APP_ORDERS_PER_PAGE;

export const ordersApi = {
  getOrders({
    page = 1,
    query,
    rest_id,
    isActiveOrders,
  }: {
    page: number;
    query: string;
    rest_id: string;
    isActiveOrders: boolean;
  }): Promise<Omit<OrdersSuccessPayload, "field" | "direction">> {
    return instance.get(
      `/v3/orders/all?page=${page}&limit=${per_page}&group_id=${rest_id}${query}${
        isActiveOrders ? "&last_day=true" : ""
      }`
    );
  },
  getOrderErrorMessage(restaurant_id: string, order_id: string) {
    return instance.get(
      `/v3/orders/get-error?restaurant_id=${restaurant_id}&order_id=${order_id}`
    );
  },
  getOrdersExcel({
    restaurantID,
    startDate,
    endDate,
    aggregators,
    statuses,
  }: {
    restaurantID: string;
    startDate: string;
    endDate: string;
    aggregators: string[];
    statuses: string[];
  }) {
    let url = `/v3/orders/excel?restaurantID=${restaurantID}&startDate=${new Date(
      startDate
    ).toISOString()}&endDate=${new Date(endDate).toISOString()}`;
    statuses.forEach((status) => {
      url += `&statuses=${encodeURIComponent(status)}`;
    });
    aggregators.forEach((aggregator) => {
      url += `&aggregators=${encodeURIComponent(aggregator)}`;
    });
    return instance.get(url);
  },
};
